import { render } from "./Lawyer.vue?vue&type=template&id=0bc3e456"
import script from "./Lawyer.vue?vue&type=script&lang=js"
export * from "./Lawyer.vue?vue&type=script&lang=js"

import "./Lawyer.vue?vue&type=style&index=0&id=0bc3e456&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__